<perfect-scrollbar class="side-nav scrollbar-wrapper" sideNav>

  <app-test-period-banner></app-test-period-banner>

  <ul
    class="ant-menu ant-menu-root ant-menu-inline side-nav-menu"
    [ngClass]="{
      'ant-menu-inline-collapsed': isFolded,
      'ant-menu-dark': isSideNavDark,
      'menu-license-expired': licenseService.expired
    }">

    @for (item of menuItems; track item) {
      <li
        [class.ant-menu-submenu]="item.submenu.length > 0"
        [class.ant-menu-submenu-inline]="item.submenu.length > 0"
        [class.ant-menu-item]="item.submenu.length === 0"
        [routerLinkActive]="item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: item.routerLinkActiveExact }">

        @if (item.submenu.length > 0) {
          <a href="javascript:void(0);"
             class="ant-menu-submenu-title"
             [ngClass]="{ 'ignore-license': item.allowIfExpired }">
            @if (item.iconType === 'lucide') { <i-lucide class="m-r-10" [name]="item.icon"></i-lucide> }
            @if (item.iconType === 'nzIcon') { <i nz-icon [nzType]="item.icon" [nzTheme]="item.iconTheme"></i> }
            @if (item.iconType === 'fontawesome') { <i class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i> }
            <span>{{ item.title | translate }}</span>
            <i class="ant-menu-submenu-arrow"></i>
          </a>
        }

        @if (item.submenu.length === 0) {
          <a [routerLink]="item.path"
             [queryParams]="item.queryParams"
             [ngClass]="{ 'ignore-license': item.allowIfExpired }">
            @if (item.iconType === 'lucide') { <i-lucide class="m-r-10" [name]="item.icon"></i-lucide> }
            @if (item.iconType === 'nzIcon') { <i nz-icon [nzType]="item.icon" [nzTheme]="item.iconTheme"></i> }
            @if (item.iconType === 'fontawesome') { <i class="m-r-10" [ngClass]="[item.iconTheme, item.icon]"></i> }
            <span>{{ item.title | translate }}</span>
          </a>
        }

        <!-- LEVEL 2: IMMER im DOM lassen -->
        <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
            [class.has-children]="item.submenu.length > 0">

          @for (subItem of item.submenu; track subItem) {
            <li
              [class.ant-menu-submenu]="subItem.submenu.length > 0"
              [class.ant-menu-submenu-inline]="subItem.submenu.length > 0"
              [class.ant-menu-item]="subItem.submenu.length === 0"
              [routerLinkActive]="subItem.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'"
              [routerLinkActiveOptions]="subItem.routerLinkActiveOptions ?? { exact: subItem.routerLinkActiveExact }">

              @if (subItem.submenu.length > 0) {
                <a href="javascript:void(0);"
                   class="ant-menu-submenu-title p-l-50"
                   [ngClass]="{ 'ignore-license': item.allowIfExpired }">
                  @if (subItem.iconType === 'lucide') { <i-lucide class="m-r-10" [name]="subItem.icon"></i-lucide> }
                  @if (subItem.iconType === 'nzIcon') { <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i> }
                  @if (subItem.iconType === 'fontawesome') { <i class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i> }
                  <span>{{ subItem.title | translate }}</span>
                  <i class="ant-menu-submenu-arrow"></i>
                </a>
              }

              @if (subItem.submenu.length === 0) {
                <a [routerLink]="subItem.path"
                   [queryParams]="subItem.queryParams"
                   class="p-l-30"
                   [ngClass]="{ 'ignore-license': item.allowIfExpired }">
                  @if (subItem.iconType === 'lucide') { <i-lucide class="m-r-10" [name]="subItem.icon"></i-lucide> }
                  @if (subItem.iconType === 'nzIcon') { <i nz-icon [nzType]="subItem.icon" [nzTheme]="subItem.iconTheme"></i> }
                  @if (subItem.iconType === 'fontawesome') { <i class="m-r-10" [ngClass]="[subItem.iconTheme, subItem.icon]"></i> }
                  <span>{{ subItem.title | translate }}</span>
                </a>
              }

              <!-- LEVEL 3: IMMER im DOM lassen -->
              <ul class="ant-menu ant-menu-inline ant-menu-sub dropdown-menu"
                  [class.has-children]="subItem.submenu.length > 0">

                @for (thirdItem of subItem.submenu; track thirdItem) {
                  <li class="ant-menu-item"
                      routerLinkActive="ant-menu-item-selected"
                      [routerLinkActiveOptions]="thirdItem.routerLinkActiveOptions ?? { exact: thirdItem.routerLinkActiveExact }">
                    <a [routerLink]="thirdItem.path"
                       [queryParams]="thirdItem.queryParams"
                       class="p-l-50"
                       [ngClass]="{ 'ignore-license': item.allowIfExpired }">
                      <span>{{ thirdItem.title | translate }}</span>
                    </a>
                  </li>
                }
              </ul>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</perfect-scrollbar>
